import React, { useState, useEffect, useCallback } from 'react'; 
import { auth, db } from '../FirebaseComp/firebase';
import { collection, getDocs, deleteDoc, doc, updateDoc, addDoc, query, orderBy, onSnapshot, limit, where, serverTimestamp } from 'firebase/firestore';
import jsPDF from 'jspdf';
import * as XLSX from 'xlsx';
import './adminpanel.css';
import emailjs from 'emailjs-com'; 

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faSave, faTimes, faSearch, faFilter } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'

import { Timestamp } from "firebase/firestore";







function AdminPanel() {
  const [activeTab, setActiveTab] = useState('addPatient'); // Default tab
  const [users, setUsers] = useState([]);


  // Fetch all users
  const fetchUsers = useCallback(async () => {
    try {
      const userRef = collection(db, 'users');
      const snapshot = await getDocs(userRef);
      const usersData = snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
      setUsers(usersData);
    } catch (error) {
      console.error("Error fetching users:", error.message);
    }
  }, []);

  useEffect(() => {
    if (activeTab === 'viewUsers' || activeTab === 'manageUsers') {
      fetchUsers();
    }
  }, [activeTab, fetchUsers]);

  // Remove user with confirmation
  const handleRemoveUser = async (userId) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this member?");
    if (!confirmDelete) return; 

    try {
      await deleteDoc(doc(db, 'users', userId));  
      setUsers(prevUsers => prevUsers.filter(user => user.id !== userId)); 
    } catch (error) {
      console.error("Error removing user:", error.message);
    }
  };

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };



  const handleLogout = async () => {
    try {
      await auth.signOut();
      window.location.href = '/';  
    } catch (error) {
      console.error("Error logging out:", error.message);
    }
  };

  useEffect(() => {
    document.body.classList.add('admin-panel-active');
    return () => {
      document.body.classList.remove('admin-panel-active');
    };
  }, []);





//fetch all the messages from the contacts
 const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        // Create a query that orders by createdAt timestamp (newest first)
        const q = query(
          collection(db, "contactus"), 
          orderBy("createdAt", "desc")
        );
        
        const querySnapshot = await getDocs(q);
        const contactMessages = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
          // Format the timestamp for display
          formattedDate: doc.data().createdAt?.toDate().toLocaleString() || 'N/A'
        }));
        
        setMessages(contactMessages);
        setError('');
      } catch (err) {
        console.error("Error fetching messages:", err);
        setError('Failed to load messages. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    fetchMessages();
  }, []);







//loyalty cutomer
const [formData, setFormData] = useState({
  name: '',
  loyaltyNumber: '',
  address: '',
  phone: '',
  email: '',
  password: ''
});

const [submitting, setSubmitting] = useState(false);
const [success, setSuccess] = useState(false);

const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData(prev => ({
    ...prev,
    [name]: value
  }));
};

const handleSubmit = async (e) => {
  e.preventDefault();
  setSubmitting(true);
  setError('');

  try {
    // 1. Save data to Firestore
    await addDoc(collection(db, 'loyaltybase'), {
      ...formData,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      status: 'active'
    });

    // 2. Send email to the customer
    await emailjs.send('service_tqyzrz1', 'template_t4cwy4h', {
      name: formData.name,
      loyaltyNumber: formData.loyaltyNumber,
      email: formData.email
    }, 'V7GeEtMQ7Wi0eUrRM');

    setSuccess(true);

    // 3. Reset form
    setFormData({
      name: '',
      loyaltyNumber: '',
      address: '',
      phone: '',
      email: '',
      password: ''
    });

    // Hide success message
    setTimeout(() => setSuccess(false), 5000);
  } catch (err) {
    console.error("Error saving or sending email:", err);
    setError('Failed to save data or send email. Please try again.');
  } finally {
    setSubmitting(false);
  }
};







// Fetch all loyalty customers
  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [yearFilter, setYearFilter] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({
    name: '',
    email: '',
    phone: '',
    address: ''
  });

  // Fetch all loyalty customers
  useEffect(() => {
    const fetchLoyaltyCustomers = async () => {
      try {
        const q = query(collection(db, "loyaltybase"));
        const querySnapshot = await getDocs(q);
        
        let loyaltyCustomers = querySnapshot.docs.map((doc) => {
          const data = doc.data();
          const joinedDate = data.createdAt?.toDate();
          return {
            id: doc.id,
            ...data,
            joinedDate,
            year: joinedDate ? joinedDate.getFullYear() : 'N/A'
          };
        });

        // Sort by loyalty number numerically
        loyaltyCustomers = loyaltyCustomers.sort((a, b) => {
          const numA = parseInt(a.loyaltyNumber.replace(/\D/g, ''), 10);
          const numB = parseInt(b.loyaltyNumber.replace(/\D/g, ''), 10);
          return numA - numB;
        });
        
        setCustomers(loyaltyCustomers);
        setFilteredCustomers(loyaltyCustomers);
        setError('');
      } catch (err) {
        console.error("Error fetching loyalty customers:", err);
        setError('Failed to load customers. Please try again.');
        toast.error('Failed to load customers');
      } finally {
        setLoading(false);
      }
    };

    fetchLoyaltyCustomers();
  }, []);

  // Filter customers based on search term and year filter
  useEffect(() => {
    let result = [...customers];
    
    // Apply search filter
    if (searchTerm.trim() !== '') {
      const term = searchTerm.toLowerCase();
      result = result.filter(customer => 
        customer.name.toLowerCase().includes(term) ||
        customer.phone.includes(searchTerm) ||
        customer.loyaltyNumber.includes(searchTerm)
      );
    }
    
    // Apply year filter
    if (yearFilter) {
      result = result.filter(customer => 
        customer.year === parseInt(yearFilter)
      );
    }
    
    setFilteredCustomers(result);
  }, [searchTerm, yearFilter, customers]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleEdit = (customer) => {
    setEditingId(customer.id);
    setEditForm({
      name: customer.name,
      email: customer.email,
      phone: customer.phone,
      address: customer.address
    });
  };

  const handleCancelEdit = () => {
    setEditingId(null);
  };

  const handleSaveEdit = async () => {
    try {
      await updateDoc(doc(db, "loyaltybase", editingId), editForm);
      
      setCustomers(customers.map(customer => 
        customer.id === editingId ? { ...customer, ...editForm } : customer
      ));
      
      toast.success('Customer updated successfully');
      setEditingId(null);
    } catch (err) {
      console.error("Error updating customer:", err);
      toast.error('Failed to update customer');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this customer?')) return;
    
    try {
      await deleteDoc(doc(db, "loyaltybase", id));
      setCustomers(customers.filter(customer => customer.id !== id));
      toast.success('Customer deleted successfully');
    } catch (err) {
      console.error("Error deleting customer:", err);
      toast.error('Failed to delete customer');
    }
  };

  // Generate year options from data
  const getYearOptions = () => {
    const years = new Set();
    customers.forEach(customer => {
      if (customer.year && customer.year !== 'N/A') {
        years.add(customer.year);
      }
    });
    return Array.from(years).sort((a, b) => b - a); // Sort descending
  };

  const formatDate = (date) => {
    if (!date) return 'N/A';
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };







//add patients
  const [formPatientData, setFormPatientData] = useState({
    name: "",
    gender: "",
    age: "",
    dob: "",
    contact: "",
    address: "",
    prescribedDate: "",
    prescriptionOld: "",
    prescriptionNew: "",
    specialDisease: "",
    followUpDate: "",
    lensType: "",
  });

  const [successMsg, setSuccessMsg] = useState("");

  const handlePatientChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handlePatientSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await addDoc(collection(db, "patients"), {
        ...formData,
        createdAt: Timestamp.now(),
      });
      setSuccessMsg("Patient added successfully!");
      setFormData({
        name: "",
        gender: "",
        age: "",
        dob: "",
        contact: "",
        address: "",
        prescribedDate: "",
        prescriptionOld: "",
        prescriptionNew: "",
        specialDisease: "",
        followUpDate: "",
        lensType: "",
      });
    } catch (error) {
      console.error("Error adding patient:", error);
    }
    setLoading(false);
  };



// fetch all patients
const [patients, setPatients] = React.useState([]);
const [editPatientId, setEditPatientId] = React.useState(null);
const [editFormData, setEditFormData] = React.useState({});
const [alertMessage, setAlertMessage] = React.useState(null); // ✅ alert state

// fetch patients from Firestore
React.useEffect(() => {
  const fetchPatients = async () => {
    const snapshot = await getDocs(collection(db, "patients"));
    setPatients(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
  };
  fetchPatients();
}, []);

// delete handler
const handlePatientDelete = async (id) => {
  if (window.confirm("Are you sure you want to delete this patient?")) {
    await deleteDoc(doc(db, "patients", id));
    setPatients(patients.filter((p) => p.id !== id));
    setAlertMessage({ type: "delete", text: "❌ Patient deleted successfully!" });
    setTimeout(() => setAlertMessage(null), 3000);
  }
};

// edit click
const handlePatientEditClick = (patient) => {
  setEditPatientId(patient.id);
  setEditFormData({ ...patient });
};

// change fields while editing
const handlePatientEditChange = (e) => {
  setEditFormData({ ...editFormData, [e.target.name]: e.target.value });
};

// save edit
const handlePatientSaveEdit = async (e, id) => {
  e.preventDefault();
  await updateDoc(doc(db, "patients", id), editFormData);
  setPatients(
    patients.map((p) => (p.id === id ? { id, ...editFormData } : p))
  );
  setEditPatientId(null);

  // ✅ success alert
  setAlertMessage({ type: "success", text: "✅ Patient updated successfully!" });
  setTimeout(() => setAlertMessage(null), 3000);
};

// cancel edit
const handlePatientCancelEdit = () => {
  setEditPatientId(null);
};






// states for search and filter
const [filterYear, setFilterYear] = React.useState("");
const [filterMonth, setFilterMonth] = React.useState("");

// 🔎 filtered patients based on search + year + month
const filteredPatients = patients.filter((patient) => {
  const nameMatch = patient.name?.toLowerCase().includes(searchTerm.toLowerCase());
  const phoneMatch = patient.contact?.includes(searchTerm);

  // check year & month filter against prescribedDate
  let dateMatch = true;
  if (filterYear || filterMonth) {
    if (patient.prescribedDate) {
      const dateObj = new Date(patient.prescribedDate);
      const year = dateObj.getFullYear().toString();
      const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");

      if (filterYear && year !== filterYear) dateMatch = false;
      if (filterMonth && month !== filterMonth) dateMatch = false;
    } else {
      dateMatch = false;
    }
  }

  return (nameMatch || phoneMatch) && dateMatch;
});

































  return (
    <div className="admin-panel">
      <div className="top-bar">
        <ul className="tabs">

              <li className={`tab ${activeTab === 'addPatient' ? 'active' : ''}`} onClick={() => handleTabClick('addPatient')}>
                Add Patient
              </li>

              <li className={`tab ${activeTab === 'viewAllPatients' ? 'active' : ''}`} onClick={() => handleTabClick('viewAllPatients')}>
                View All Patients
              </li>

              <li className={`tab ${activeTab === 'followups' ? 'active' : ''}`} onClick={() => handleTabClick('followups')}>
                Follow-Ups
              </li>
{/* 
              <li className={`tab ${activeTab === 'addLoyaltyCustomer' ? 'active' : ''}`} onClick={() => handleTabClick('addLoyaltyCustomer')}>
                Add Loyalty Customer
              </li>

              <li className={`tab ${activeTab === 'viewAllLoyaltyBase' ? 'active' : ''}`} onClick={() => handleTabClick('viewAllLoyaltyBase')}>
                View All Loyalty Customers
              </li>


          <li className={`tab ${activeTab === 'feedbacks' ? 'active' : ''}`} onClick={() => handleTabClick('feedbacks')}>
            Feedbacks
          </li>


          <li className={`tab ${activeTab === 'contactMessage' ? 'active' : ''}`} onClick={() => handleTabClick('contactMessage')}>
            Contact Us Messages
          </li> */}

        </ul>
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>

      <div className="main-content">


{/******************************************************************************************************************************/}


{activeTab === "addPatient" && (
  <div className="add-patient-container">
    <h3 className="add-patient-heading">Add Patient</h3>

    <form onSubmit={handlePatientSubmit} className="add-patient-form">
      
      {/* Patient Name */}
      <div className="add-patient-formgroup">
        <label htmlFor="name">Patient Name</label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handlePatientChange}
          required
        />
      </div>

      {/* Gender */}
      <div className="add-patient-formgroup">
        <label htmlFor="gender">Gender</label>
        <select
          id="gender"
          name="gender"
          value={formData.gender}
          onChange={handlePatientChange}
          required
        >
          <option value="">Select Gender</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
          <option value="Other">Other</option>
        </select>
      </div>

      {/* Age */}
      <div className="add-patient-formgroup">
        <label htmlFor="age">Age</label>
        <input
          type="number"
          id="age"
          name="age"
          value={formData.age}
          onChange={handlePatientChange}
          required
        />
      </div>

      {/* Date of Birth */}
      <div className="add-patient-formgroup">
        <label htmlFor="dob">Date of Birth</label>
        <input
          type="date"
          id="dob"
          name="dob"
          value={formData.dob}
          onChange={handlePatientChange}
          required
        />
      </div>

      {/* Contact Number */}
      <div className="add-patient-formgroup">
        <label htmlFor="contact">Contact Number</label>
        <input
          type="text"
          id="contact"
          name="contact"
          value={formData.contact}
          onChange={handlePatientChange}
          required
        />
      </div>

      {/* Address */}
      <div className="add-patient-formgroup full-width">
        <label htmlFor="address">Address</label>
        <input
          type="text"
          id="address"
          name="address"
          value={formData.address}
          onChange={handlePatientChange}
        />
      </div>

      {/* Prescribed Date */}
      <div className="add-patient-formgroup">
        <label htmlFor="prescribedDate">Prescribed Date</label>
        <input
          type="date"
          id="prescribedDate"
          name="prescribedDate"
          value={formData.prescribedDate}
          onChange={handlePatientChange}
          required
        />
      </div>

      {/* Follow Up Date */}
      <div className="add-patient-formgroup">
        <label htmlFor="followUpDate">Follow Up Date</label>
        <input
          type="date"
          id="followUpDate"
          name="followUpDate"
          value={formData.followUpDate}
          onChange={handlePatientChange}
        />
      </div>

      {/* Prescription Old */}
      <div className="add-patient-formgroup full-width">
        <label htmlFor="prescriptionOld">Old Prescription</label>
        <textarea
          id="prescriptionOld"
          name="prescriptionOld"
          value={formData.prescriptionOld}
          onChange={handlePatientChange}
        />
      </div>

      {/* Prescription New */}
      <div className="add-patient-formgroup full-width">
        <label htmlFor="prescriptionNew">New Prescription</label>
        <textarea
          id="prescriptionNew"
          name="prescriptionNew"
          value={formData.prescriptionNew}
          onChange={handlePatientChange}
        />
      </div>

      {/* Special Disease */}
      <div className="add-patient-formgroup full-width">
        <label htmlFor="specialDisease">Special Disease</label>
        <input
          type="text"
          id="specialDisease"
          name="specialDisease"
          value={formData.specialDisease}
          onChange={handlePatientChange}
        />
      </div>

      {/* Lens Type */}
      <div className="add-patient-formgroup full-width">
        <label htmlFor="lensType">Lens Type</label>
        <input
          type="text"
          id="lensType"
          name="lensType"
          value={formData.lensType}
          onChange={handlePatientChange}
        />
      </div>

      {/* Submit */}
      <div className="add-patient-formgroup full-width">
        <button type="submit" disabled={loading}>
          {loading ? "Saving..." : "Save Patient"}
        </button>
      </div>
    </form>



{/* Success alert */}
{successMsg && (
  <div className="success-alert">
    {successMsg}
  </div>
)}




  </div>
)}


{/******************************************************************************************************************************/}

{activeTab === "viewAllPatients" && (
  <div className="viewAllPatients-container">
    <h3 className="heading-view-all-patients">View All Patients</h3>

    {/* ✅ Alert Messages */}
    {alertMessage && (
      <div
        className={`alert ${
          alertMessage.type === "success" ? "alert-success" : "alert-delete"
        }`}
      >
        {alertMessage.text}
      </div>
    )}

    {/* ✅ Search & Filter Section */}
    <div className="filters">
      <input
        type="text"
        placeholder="Search by name or phone..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      <select value={filterYear} onChange={(e) => setFilterYear(e.target.value)}>
        <option value="">All Years</option>
        {[...Array(20)].map((_, i) => {
          const year = 2020 + i;
          return (
            <option key={year} value={year}>
              {year}
            </option>
          );
        })}
      </select>

      <select
        value={filterMonth}
        onChange={(e) => setFilterMonth(e.target.value)}
      >
        <option value="">All Months</option>
        {[
          "01-January",
          "02-February",
          "03-March",
          "04-April",
          "05-May",
          "06-June",
          "07-July",
          "08-August",
          "09-September",
          "10-October",
          "11-November",
          "12-December",
        ].map((m) => {
          const [val, label] = m.split("-");
          return (
            <option key={val} value={val}>
              {label}
            </option>
          );
        })}
      </select>
    </div>

    {/* ✅ Patients Table */}
    <table className="viewAllPatients-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Gender</th>
          <th>Age</th>
          <th>DOB</th>
          <th>Contact</th>
          <th>Address</th>
          <th>Prescribed Date</th>
          <th>Old Prescription</th>
          <th>New Prescription</th>
          <th>Special Disease</th>
          <th>Lens Type</th>
          <th>Follow Up</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {filteredPatients.map((patient) => (
          <React.Fragment key={patient.id}>
            {editPatientId === patient.id ? (
              <tr>
                {/* Editable Row */}
                <td colSpan="13">
                  <form
                    className="edit-patient-form"
                    onSubmit={(e) => handlePatientSaveEdit(e, patient.id)}
                  >
                    <div className="edit-form-grid">
                      <label>
                        Name
                        <input
                          type="text"
                          name="name"
                          value={editFormData.name}
                          onChange={handlePatientEditChange}
                          required
                        />
                      </label>
                      <label>
                        Gender
                        <select
                          name="gender"
                          value={editFormData.gender}
                          onChange={handlePatientEditChange}
                          required
                        >
                          <option value="">Select</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Other">Other</option>
                        </select>
                      </label>
                      <label>
                        Age
                        <input
                          type="number"
                          name="age"
                          value={editFormData.age}
                          onChange={handlePatientEditChange}
                          required
                        />
                      </label>
                      <label>
                        Date of Birth
                        <input
                          type="date"
                          name="dob"
                          value={editFormData.dob}
                          onChange={handlePatientEditChange}
                          required
                        />
                      </label>
                      <label>
                        Contact
                        <input
                          type="text"
                          name="contact"
                          value={editFormData.contact}
                          onChange={handlePatientEditChange}
                          required
                        />
                      </label>
                      <label className="full-width">
                        Address
                        <input
                          type="text"
                          name="address"
                          value={editFormData.address}
                          onChange={handlePatientEditChange}
                        />
                      </label>
                      <label>
                        Prescribed Date
                        <input
                          type="date"
                          name="prescribedDate"
                          value={editFormData.prescribedDate}
                          onChange={handlePatientEditChange}
                          required
                        />
                      </label>
                      <label>
                        Follow Up Date
                        <input
                          type="date"
                          name="followUpDate"
                          value={editFormData.followUpDate}
                          onChange={handlePatientEditChange}
                        />
                      </label>
                      <label className="full-width">
                        Old Prescription
                        <textarea
                          name="prescriptionOld"
                          value={editFormData.prescriptionOld}
                          onChange={handlePatientEditChange}
                        />
                      </label>
                      <label className="full-width">
                        New Prescription
                        <textarea
                          name="prescriptionNew"
                          value={editFormData.prescriptionNew}
                          onChange={handlePatientEditChange}
                        />
                      </label>
                      <label className="full-width">
                        Special Disease
                        <input
                          type="text"
                          name="specialDisease"
                          value={editFormData.specialDisease}
                          onChange={handlePatientEditChange}
                        />
                      </label>
                      <label className="full-width">
                        Lens Type
                        <input
                          type="text"
                          name="lensType"
                          value={editFormData.lensType}
                          onChange={handlePatientEditChange}
                        />
                      </label>
                    </div>
                    <div className="edit-actions">
                      <button type="submit" className="btn-save">
                        Save
                      </button>
                      <button
                        type="button"
                        className="btn-cancel"
                        onClick={handlePatientCancelEdit}
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </td>
              </tr>
            ) : (
              <tr>
                <td>{patient.name}</td>
                <td>{patient.gender}</td>
                <td>{patient.age}</td>
                <td>{patient.dob}</td>
                <td>{patient.contact}</td>
                <td>{patient.address}</td>
                <td>{patient.prescribedDate}</td>
                <td>{patient.prescriptionOld}</td>
                <td>{patient.prescriptionNew}</td>
                <td>{patient.specialDisease}</td>
                <td>{patient.lensType}</td>
                <td>{patient.followUpDate}</td>
                <td>
                  <div className="action-buttons">
                    <button
                      className="btn-edit"
                      onClick={() => handlePatientEditClick(patient)}
                    >
                      <span>&#9998;</span>
                    </button>
                    <button
                      className="btn-delete"
                      onClick={() => handlePatientDelete(patient.id)}
                    >
                      <span>&#x1F5D1;</span>
                    </button>
                  </div>
                </td>
              </tr>
            )}
          </React.Fragment>
        ))}
      </tbody>
    </table>
  </div>
)}




{/******************************************************************************************************************************/}

{activeTab === 'followups' && (
  <div className="followups-container">
    <div className="followups-header">
      <h3 className="heading-followups">Upcoming Follow-ups</h3>
      <span className="today-count">
        Today:{" "}
        {
          patients.filter((p) => {
            if (!p.followUpDate) return false;
            const today = new Date();
            const followUpDate = new Date(p.followUpDate);
            return (
              followUpDate.getFullYear() === today.getFullYear() &&
              followUpDate.getMonth() === today.getMonth() &&
              followUpDate.getDate() === today.getDate()
            );
          }).length
        }
      </span>
    </div>

    <div className="followups-list">
      {patients
        .filter((p) => {
          if (!p.followUpDate) return false;
          const followUpDate = new Date(p.followUpDate);
          const today = new Date();
          const daysRemaining = Math.ceil(
            (followUpDate - today) / (1000 * 60 * 60 * 24)
          );
          return daysRemaining >= 0; // hide overdue
        })
        .map((p) => {
          const followUpDate = new Date(p.followUpDate);
          const today = new Date();
          const daysRemaining = Math.ceil(
            (followUpDate - today) / (1000 * 60 * 60 * 24)
          );

          return {
            ...p,
            followUpDate,
            daysRemaining,
          };
        })
        .sort((a, b) => a.daysRemaining - b.daysRemaining) // soonest first
        .map((patient) => {
          const formattedDate = patient.followUpDate.toLocaleDateString(
            "en-US",
            {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
            }
          );

          let urgencyClass = "";
          if (patient.daysRemaining <= 3) urgencyClass = "red";
          else if (patient.daysRemaining <= 10) urgencyClass = "orange";
          else if (patient.daysRemaining <= 20) urgencyClass = "green";

          return (
            <div key={patient.id} className={`followup-item ${urgencyClass}`}>
              <div className="followup-left">
                <h4 className="patient-name">{patient.name}</h4>
                <p className="contact">📞 {patient.contact}</p>
              </div>

              <div className="followup-right">
                <p className="followup-date">📅 {formattedDate}</p>
                <span className="days-remaining">
                  {patient.daysRemaining === 0
                    ? "📌 Today"
                    : `⏳ ${patient.daysRemaining} days`}
                </span>
              </div>
            </div>
          );
        })}
    </div>
  </div>
)}


{/******************************************************************************************************************************/}






{/******************************************************************************************************************************/}



  


{/******************************************************************************************************************************/}


   





{/******************************************************************************************************************************/}

      

{/******************************************************************************************************************************/}


    

{/******************************************************************************************************************************/}


      </div>
    </div>
  );
}

export default AdminPanel;
